import theme from "../../../style/theme";
import { createPolyline } from "./create-polyline";

export const createYellowPolyline = (
  map: naver.maps.Map,
  path: naver.maps.LatLng[]
) => {
  return createPolyline(map, theme.palette.primitives["yellow400"], path);
};
